import { NavLink, type NavLinkProps } from '@mantine/core'
import { useTabAwareNavHandlers } from '@/lib/workspace-tabs-context'

export type TabAwareNavLinkProps = Omit<NavLinkProps, 'component' | 'href'> & {
  to: string
}

export function TabAwareNavLink({ to, onClick, ...rest }: TabAwareNavLinkProps) {
  const { onClick: tabClick, onAuxClick, href } = useTabAwareNavHandlers(to)
  return (
    <NavLink
      component="a"
      href={href}
      onClick={(e) => {
        onClick?.(e)
        if (e.defaultPrevented) return
        tabClick(e)
      }}
      onAuxClick={onAuxClick}
      {...rest}
    />
  )
}
